import config from 'const/config'
import useSearchParam from 'ui/customHooks/useSearchParam'

const TRANSMIT_MOCK_PARAM = 'transmit-mock'

export const useTransmitMockParam = () =>
  useSearchParam<TrueFalseString>(TRANSMIT_MOCK_PARAM)

export const useTransmitMock = (): boolean => {
  const [transmitValue] = useTransmitMockParam()

  /*
   * Only permit transmit mocking where msw is permitted. Comparing to exactly
   * "yes" to bias the logic towards return false (no mock). If the ALLOW_MSW is
   * not set, then no transmit. If its set to "false" instead of "no", it will
   * return false. Etc.
   */
  if (config.ALLOW_MSW === 'yes') {
    return transmitValue === 'true'
  }
  return false
}

export default useTransmitMock
